import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthProvider';
import { mobileMenu } from '../../../utils';
import { getPromoterEvents } from '../../../services/PromoterService';

function MobileMainNav(props) {
    const { user, loggedIn, organizerId, organizerList, userRole } = useContext(AuthContext);
    const [events, setEvents] = useState([]);

    useEffect(() => {
        mobileMenu();
        showMySales()
    }, [user, organizerList, userRole]);

    const showManageEvents = () => {
        if (userRole) {
            console.log("User role111", userRole);
            if (userRole === "SADMIN") {
                return true;
            } else if (organizerId) {
                if (userRole === "ADMIN" || userRole === "INSPEC") {
                    return true;
                } else if (organizerList && organizerList.permissions && organizerList.permissions.length > 0) {
                    return true;

                }
            } else {
                console.log("No permission to manage events");
            }
        }
        return false;
    }

    const showMySales = async () => {
       
        try {
            if(!loggedIn || !user) return false;
            console.log("User role: ", user);
            const res = await getPromoterEvents(user.id);
            console.log("Events: ", res.data);
            if (res.data.length > 0) {
                setEvents(res.data);
                return true;
            }
            return false;


        } catch (err) {
            // setError(err.message);
            console.log("error fetching events: ", err.message)
            return false;
        }
    }

    return (
        <nav className="mobile-nav">
            <ul className="mobile-menu">
                <li>
                    <Link to={`${process.env.PUBLIC_URL}`}>
                        Home
                    </Link>
                </li>
                <li>
                    <Link to={`${process.env.PUBLIC_URL}/events`}>
                        Events
                    </Link>
                </li>
                <li>
                    <Link to={`${process.env.PUBLIC_URL}/pages/about`} >
                        About
                    </Link>
                </li>
                {/* <li>
                    <Link to={ `${process.env.PUBLIC_URL}/pages/contact` }>
                        Contact
                    </Link>
                </li> */}
                {
                    loggedIn &&
                    <li>
                        <Link className="sf" to={{ pathname: '/shop/dashboard', state: { goto: 2 } }}>Orders</Link>
                    </li>
                }
                {/* {
                    organizerId &&
                    <li>
                        <Link className="sf" to="/organizer/events" >Manage Events</Link>
                    </li>
                } */}

                {showManageEvents() && <ul><li><Link to="/organizer/events">MANAGE EVENTS</Link></li></ul>}

                {loggedIn && user && (((events && events.length)) ? (<ul><li><Link to="/promoter">MY SALES</Link></li></ul>) : null)}

                {/* { organizerId && ( <ul><li><Link to="/organizer/checkin">CHECKIN</Link></li></ul> )} */}

            </ul>
        </nav>
    );
}

export default MobileMainNav;